<template>
  <div v-if="profile">
    <UpdateAvailability
      :show-availability-dialog="availabilityDialog"
      @hideModal="hideAvailabilityDialog"
    >
      <template slot="updateAvailabiltyButton">
        <v-row
          align="center"
          no-gutters
        >
          <v-col>
            Availability:
            <span class="grey--text mr-2">{{ profile.weeklyAvailability }}</span>
          </v-col>

          <v-col cols="auto">
            <v-btn
              x-small
              fab
              icon
              color="grey"
            >
              <v-icon
                dark
                small
                @click="showAvailabilityDialog"
              >
                edit
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </UpdateAvailability>
  </div>
</template>

<script lang="ts">
import { mapGetters } from 'vuex'
import { Component, Vue } from 'vue-property-decorator'

import UpdateAvailability from '@/components/core/UpdateAvailability.vue'
import { IUser } from '@/types/models/user.model'
import { ProfilePageSection } from '@/router'

@Component({
  components: {
    UpdateAvailability,
  },
  computed: {
    ...mapGetters(['profile']),
  }
})
export default class UserAvailability extends Vue {
  availabilityDialog: boolean = false

  // computed
  profile: IUser|null

  created () {
    if (this.$route.params.section === ProfilePageSection.availability) {
      this.availabilityDialog = true
    }
  }

  showAvailabilityDialog () {
    this.availabilityDialog = true
  }

  hideAvailabilityDialog () {
    this.availabilityDialog = false
  }
}
</script>
